import { render, staticRenderFns } from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementLink.vue?vue&type=template&id=b01d7c14&scoped=true"
import script from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementLink.vue?vue&type=script&lang=js"
export * from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementLink.vue?vue&type=script&lang=js"
import style0 from "./EMelderComponentEinstellungenMeldungsvorlagenRightElementLink.vue?vue&type=style&index=0&id=b01d7c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01d7c14",
  null
  
)

export default component.exports